// An HTML letter in a sandbox (HomeMail, R-053 there): no scripts, no forms, no network — a CSP inside the frame blocks remote
// images and trackers; links open in a new tab. The frame grows to its content, so the chain scrolls as one page.

import { useEffect, useRef, useState } from 'react';
import s from './mail.module.css';

const CSP = "default-src 'none'; style-src 'unsafe-inline'; img-src data:; font-src data:";
const BASE = '<meta charset="utf-8"><base target="_blank"><style>html,body{margin:0;padding:0;background:#fff;color:#18181b;font:14px/1.5 Inter,system-ui,sans-serif;overflow-wrap:anywhere}img{max-width:100%;height:auto}table{max-width:100%}blockquote{margin:0 0 0 8px;padding-left:8px;border-left:2px solid #ddd;color:#555}</style>';

export function HtmlFrame({ html }: { html: string }) {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const [height, setHeight] = useState(120);
  const doc = `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="${CSP}">${BASE}</head><body>${html}</body></html>`;
  useEffect(() => {
    const f = ref.current;
    if (!f) return;
    let ro: ResizeObserver | null = null;
    const measure = () => { const b = f.contentDocument?.documentElement; if (b) setHeight(Math.min(20000, b.scrollHeight + 4)); };
    const onLoad = () => { measure(); const b = f.contentDocument?.body; if (b) { ro = new ResizeObserver(measure); ro.observe(b); } };
    f.addEventListener('load', onLoad);
    return () => { f.removeEventListener('load', onLoad); ro?.disconnect(); };
  }, [doc]);
  // allow-same-origin without allow-scripts: nothing runs inside, the page only measures the height.
  return <iframe ref={ref} className={s.frame} title="Текст письма" sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" srcDoc={doc} style={{ height }} />;
}
